import fetchClient, { ApiResponse } from '@/api/api-client'
import { UpdateUserPayload } from '@/api/auth/mutations/useUpdateUser'
import { CognitoUser, FormattedCognitoUser, LoggedUser } from '@/api/auth/types/LoggedUser'

import type { AddCreditPayload } from './types/AddCreditPayload'
import { User } from './types/User'

export async function listUsers(params: string, limit?: number, next?: string) {
  const payload = {
    params,
    limit,
    pageToken: next,
  }
  const res = await fetchClient.post<ApiResponse<{ users: CognitoUser[] }>>('/users', payload)
  return res.data.data
}

export async function searchUserByPhoneOrTracking(searchFields: { trackingNumberInTurkey?: string; phoneNumber?: string }) {
  const res = await fetchClient.post<ApiResponse<CognitoUser>>('/users/search', searchFields)
  return res.data.data
}

export async function getUser(userId: string) {
  const res = await fetchClient.get<ApiResponse<CognitoUser>>(`/users/${userId}`)
  return res.data.data ? formatCognitoUser(res.data.data) : null
}

export async function getCurrentUser() {
  const res = await fetchClient.get<ApiResponse<LoggedUser>>(`/users/me`)
  return res.data.data
}

export async function updateUser(params: UpdateUserPayload) {
  const res = await fetchClient.post(`/users/update`, params)
  return res.data.data
}

export async function deleteUser(username: string) {
  const res = await fetchClient.delete(`/users/${username}`)
  return res.data.data
}

export async function confirmUser(username: string) {
  const res = await fetchClient.post(`/auth/admin-confirm-user`, { username })
  return res.data.data
}

export async function currentAuthenticatedUser() {
  const token = JSON.parse(localStorage.getItem('cognito-tokens') || '{}')
  return Object.keys(token).length > 0 && (await getCurrentUser())
}

export async function getUserData(userId: string) {
  const res = await fetchClient.get<ApiResponse<User>>(`/users/data/${userId}`)
  return res.data.data
}

export async function addCredit(payload: AddCreditPayload): Promise<User> {
  const res = await fetchClient.post<ApiResponse<User>>('/users/credit/add', payload)
  return res.data.data
}
const formatCognitoUser = (user: CognitoUser) => {
  return user.Attributes.reduce((acc, att) => {
    acc[att.Name as keyof FormattedCognitoUser] = att.Value
    return acc
  }, {} as FormattedCognitoUser)
}
